import React from 'react'
import DataSource from '../DataSource'
import Tab from '../components/Tab'
import PlainText from '../components/PlainText'
import Heading from '../components/Heading'
import globals from '../globals'

class MobileCharges extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            title: '',
            description: '',
            titleVariable: '',
            titleAll: '',
            differentCharges: [],
            allCharges: []
        }
    }

    componentDidMount () {
        DataSource.getData('/api/getContent/mobile/charges', response => {
            this.setState({
                ...response,
                isLoaded: true
            })
        })
        globals.pushGA4Events("pageLoad", {
            eventInfo: {
                pageName: "Mobile Charges",
                pageCategory: "Mobile",
                pageType: "Information"
            }
        });
    }

    render () {
        return (
            <Tab isLoaded={this.state.isLoaded} className='mobile-charges'>
                <Heading title={this.state.title} description={this.state.description} type='h2' className='text-center mb-0' />
                <div className='row pt-5'>
                    <div className='col-12 col-lg-10 offset-lg-1'>
                        <h4 className='mt-0 bold text-center'>{this.state.titleVariable}</h4>
                        {this.state.differentCharges.map((item, key) => {
                            return <PlainText key={key} data={item} excludeTitle />
                        })}
                    </div>
                </div>
                <div className='row pb-5 mt-3'>
                    <div className='col-12 col-lg-8 offset-lg-2'>
                        <h4 className='mt-0 bold text-center'>{this.state.titleAll}</h4>
                        {this.state.allCharges.map((item, key) => {
                            return <PlainText key={key} data={item} excludeTitle />
                        })}
                    </div>
                </div>
            </Tab>
        )
    }
}

export default MobileCharges



// WEBPACK FOOTER //
// ./resources/js/mobile/MobileCharges.js